import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./components/Home";
import Profile from "./components/Profile";
import About from "./components/About";
import Auth from "./components/Auth";
import { useState,useRef,useEffect } from "react";
import Cookies from "universal-cookie";
import { signOut } from "firebase/auth";
import {auth} from "./firebase-config"
import {Card,Button} from "antd"
import { Navigate } from "react-router-dom";
function App() {

  const cookies = new Cookies();
  const [isAuth, setIsAuth] = useState(cookies.get("auth-token"));
  const [room, setRoom] = useState(null);
 const roomInputRef= useRef();
  useEffect(() => {

    

  },[])


  if (!isAuth) {
    return (
      <div>
      <Auth isAuth={isAuth} setAuth ={setIsAuth}></Auth>
      </div>
    ); }

  const signOuter = async()=> {
    await signOut(auth);
    cookies.remove();
    setIsAuth(null);
    setRoom(null);
  }

  return (
     
    <div style={{display:"flex", flexDirection:"column", marginLeft:"30%",marginTop:"10%"}}>
  
      <h1>ClanChat</h1>
      <Card 
      hoverable={true}
      style={{ width:"50%",display:"flex", flexDirection:"column",gap:"5rem", justifyContent:"center",alignItems:"center"} }
      >
       {room ? (
        <Home room={room} signOut={signOuter}></Home> 
      ) : (
        <div className="room" style={{display:"flex",flexDirection:"column" , gap:"20px" }}>
          {" "}
          <label>Room Name</label>
          <input  type="text" ref={roomInputRef} />
          <Button onClick={()=>(setRoom(roomInputRef.current.value))}>Submit</Button>
          <Button onClick={signOuter}> Sign OUT </Button>
        </div>
       
      )}
       </Card>
    </div>
  );
  
}

export default App;
